import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/auth-context';

/**
 * Smart root redirect component
 * - If authenticated: go to home page
 * - If not authenticated: go to demo landing page
 */
export function RootRedirect() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Authenticated users go to their home page
  // Unauthenticated users see the demo landing
  return <Navigate to={isAuthenticated ? '/home' : '/demo'} replace />;
}

